let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eJn7C")).then(() => parcelRequire('6CDte'));